<div class="thumbs mt-2" *ngIf="isVisible">
    <span class="lbl-rate-us p-3">RATE THIS SECTION</span>
    <span class="p-3" (click)="featureFeedback('👍')">
        <img src="/assets/thumbs up.png" alt="" />
    </span>
    <span class="p-3" (click)="featureFeedback('👎')">
        <img src="/assets/thumbs down.png" alt="" />
    </span>
</div>
